export type SubscriptionPlan = 'starter' | 'premium' | 'pro';

export interface UserSubscription {
    plan: SubscriptionPlan;
    status: 'active' | 'cancelled' | 'expired' | 'past_due' | 'trial';
    startDate: string; // ISO Date
    endDate: string; // ISO Date
    autoRenew: boolean;
    provider?: 'stripe' | 'manual' | 'apple' | 'google';
    customerId?: string; // Stripe Customer ID
    trialEndsAt?: string; // ISO Date
}

export interface SubscriptionLimits {
    maxGroups: number;
    maxPlayersPerGroup: number;
    canCreateTournaments: boolean;
    maxTournamentPlayers: number;
    canExportToExcel: boolean;
    canUploadGroupLogo: boolean; // Pro/Club only - upload custom group logo
    maxSponsors: number; // Number of sponsors allowed
    canAccessKioskMode: boolean; // Access to Live TV/Kiosk mode
    hasAdvancedStats: boolean; // Kept for backward compatibility/master switch if needed, but we will rely on statsConfig
    statsConfig: {
        showElo: boolean;
        showBadges: boolean;
        showHallOfFame: boolean;
        showDetailedStats: boolean; // Winrate, matches count, W/L ratio
    };
    hasAds: boolean;
}

export const DEFAULT_SUBSCRIPTION_LIMITS: Record<SubscriptionPlan, SubscriptionLimits> = {
    starter: {
        maxGroups: 1,
        maxPlayersPerGroup: 8,
        canCreateTournaments: false,
        maxTournamentPlayers: 16,
        canExportToExcel: false,
        canUploadGroupLogo: false, // Starter: emoji only
        maxSponsors: 0,
        canAccessKioskMode: false,
        hasAdvancedStats: false,
        statsConfig: {
            showElo: false,
            showBadges: false,
            showHallOfFame: false,
            showDetailedStats: false
        },
        hasAds: true
    },
    premium: {
        maxGroups: 5,
        maxPlayersPerGroup: 20,
        canCreateTournaments: true,
        maxTournamentPlayers: 32,
        canExportToExcel: false,
        canUploadGroupLogo: false, // Premium: emoji only
        maxSponsors: 1, // Premium: 1 sponsor max
        canAccessKioskMode: false,
        hasAdvancedStats: true,
        statsConfig: {
            showElo: true,
            showBadges: true,
            showHallOfFame: true,
            showDetailedStats: true
        },
        hasAds: false
    },
    pro: {
        maxGroups: 20,
        maxPlayersPerGroup: 100,
        canCreateTournaments: true,
        maxTournamentPlayers: 128,
        canExportToExcel: true,
        canUploadGroupLogo: true, // Pro/Club: upload custom logo
        maxSponsors: 10, // Pro: 10 sponsors
        canAccessKioskMode: true,
        hasAdvancedStats: true,
        statsConfig: {
            showElo: true,
            showBadges: true,
            showHallOfFame: true,
            showDetailedStats: true
        },
        hasAds: false
    }
};
